export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/files-icon.svg?28481aaacbd580bb4501f8040dcf607d";